var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 954.04,
    height: 682.99,
    viewBox: "0 0 954.04 682.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 241.683,
    height: 286.056,
    fill: "#f587c7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 280.183,
    height: 399.236,
    fill: "#f587c7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 297.729,
    height: 281.053,
    fill: "#f587c7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 318.228,
    height: 370.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 945.692,
    height: 449.778,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(-83.437 -223.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(690.231 855.076) rotate(-82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 62.552)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M58.012,10.565c57-28.838,131.332,3.391,166.032,71.975s16.626,147.57-40.374,176.4S52.338,255.557,17.639,186.968,1.013,39.4,58.012,10.565",
    transform: "translate(0 8.274)",
    fill: "#f587c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M10.337,2.032a18.835,18.835,0,1,1-8.3,25.307,18.834,18.834,0,0,1,8.3-25.307",
    transform: "translate(164.832 248.38)",
    fill: "#f587c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M10.337,2.032a18.835,18.835,0,1,1-8.3,25.307,18.834,18.834,0,0,1,8.3-25.307",
    transform: "translate(39.173 0)",
    fill: "#f587c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 156.092, 468.126)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M11.892,81.738a137.58,137.58,0,1,0,181.6-69.846,137.584,137.584,0,0,0-181.6,69.846",
    transform: "translate(0 124.006)",
    fill: "#f587c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M7.492,51.492a86.673,86.673,0,1,0,114.4-44,86.67,86.67,0,0,0-114.4,44",
    transform: "translate(106.796 49.204)",
    fill: "#f587c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M0,0A63.116,63.116,0,0,1,40.522,79.533",
    transform: "translate(169.664 9.502)",
    fill: "none",
    stroke: "#f587c7",
    strokeLinejoin: "round",
    strokeWidth: 14
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(691.324 261.703) rotate(13)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M261.921,10.845c-31.52-21.3-78.373-10.3-113,24.852C115.209,1.481,69.93-9.826,38.472,9.241c-.24.135-.467.291-.7.429q-.843.5-1.673,1.019c-.479.3-.958.6-1.427.914-.658.439-1.306.9-1.949,1.363-.271.2-.551.382-.819.583A65.121,65.121,0,0,0,16.376,30.039C-1.909,56.987-5.767,99.217,9.314,140.478,21.09,172.7,41.95,197.564,65.308,210.72a63.375,63.375,0,0,0,83.579-11.157,63.448,63.448,0,0,0,83.907,10.944c23.2-13.22,43.9-37.984,55.617-70.028C307.864,87.256,295.824,32.4,261.921,10.845",
    transform: "translate(0 59.427)",
    fill: "#f587c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M140.7,22.858v.117A119.112,119.112,0,0,0,0,23.013,118.738,118.738,0,0,0,70.372,46.024,118.75,118.75,0,0,0,140.7,23.051v80.921h15.991V22.858Z",
    transform: "translate(0.176 0)",
    fill: "#f587c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(73.587 432.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(0 57.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 449.944, 109.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M282.408,282.408C346,190.031,322.66,63.593,230.283,0L0,334.532c92.375,63.589,218.814,40.253,282.408-52.124",
    transform: "translate(0.001 0.001)",
    fill: "#f587c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M8.569,23.679C1.435,18.3,0,1.031,0,1.031S17-2.321,24.129,3.063A12.915,12.915,0,1,1,8.569,23.679",
    transform: "translate(165.23 192.03)",
    fill: "#15512c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M22.074,25.707C13.223,26.943,0,15.751,0,15.751S9.648,1.362,18.5.126a12.915,12.915,0,1,1,3.575,25.581",
    transform: "translate(175.907 136.575)",
    fill: "#15512c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M.14,18.382C1.443,9.541,15.9,0,15.9,0S27,13.306,25.693,22.149A12.915,12.915,0,1,1,.14,18.382",
    transform: "translate(114.901 215.702)",
    fill: "#15512c"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 50.643,
    cy: 51.564,
    rx: 50.643,
    ry: 51.564,
    transform: "translate(378.718 158.998)",
    fill: "#f587c7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 50.643,
    cy: 51.564,
    rx: 50.643,
    ry: 51.564,
    transform: "translate(495.645 239.532)",
    fill: "#f587c7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 50.643,
    cy: 50.643,
    r: 50.643,
    transform: "translate(530.647 109.276)",
    fill: "#f587c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(18.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 943.823,
    height: 448.09,
    transform: "translate(0.934 0.844)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 847.359,
    height: 38.365,
    transform: "translate(69.86 78.69)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 847.359,
    height: 38.365,
    transform: "translate(69.86 205.085)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 847.359,
    height: 38.365,
    transform: "translate(69.86 331.481)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.69952631919b142791eef97c382f0f4f.svg";
export { ForwardRef as ReactComponent };